import PropTypes from 'prop-types'
import React, { Component } from 'react'
import BannerBase from './Base'
import { selectors as UISelectors, actions as UIActions } from 'data/ui'
import { connect } from 'react-redux'

class BannerWarning extends Component {
  static propTypes = {
    warningMessage: PropTypes.string,
    setWarningMessage: PropTypes.func.isRequired,
  }

  componentWillReceiveProps({ warningMessage }) {
    clearTimeout(this.closeBannerInterval)
    if (warningMessage) {
      setTimeout(() => {
        this.onClose()
      }, 5000)
    }
  }

  onClose = () => {
    this.props.setWarningMessage(null)
  }

  render() {
    if (!this.props.warningMessage) {
      return false
    }
    return (
      <BannerBase onClose={this.onClose} warning closable>
        {this.props.warningMessage}
      </BannerBase>
    )
  }
}

export default connect(
  state => ({
    warningMessage: UISelectors.getWarningMessage(state),
  }),
  { ...UIActions }
)(BannerWarning)
